module.exports = __webpack_public_path__ + "img/downloadImg.eeb9dda9.png";